import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Ticket from "./components/Ticket";
import paymeBackground from "../svg/paymeBackground.png";


const Tickets = (props) => {
  const [t, i18n] = useTranslation("global");
  const [showTickets, setShowTickets] = useState(true);
  const [typeTicketsState, setTypeTickets] = useState();
  let background = {
    backgroundImage: `url(${paymeBackground})`,
    height: "100%",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPositionY: "top",
    width: "100%",
    position: "relative",
  };
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;
  const CONVENTION_ID = process.env.REACT_APP_CONVENTION_ID;

  useEffect(() => {
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toISOString().split("T")[0];
    };

    const fetchSchedule = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}tickets?convention_id=${CONVENTION_ID}&api_token=${API_TOKEN}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const json_data = await response.json();
        if (json_data["message"] === "success") {
          const formattedData = json_data["data"].map((item) => ({
            ...item,
            from: formatDate(item.from),
            to: formatDate(item.to),
          }));
          setTypeTickets(formattedData);
        } else {
          //
        }
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };
    fetchSchedule();
  }, [props.language]);

  return (
    <div style={background} className="relative">
      <div
        className="absolute inset-0 bg-white opacity-60"
        style={{ zIndex: 1 }}
      ></div>
      <div className="App mx-auto flex justify-center relative z-10">
        <div
          className="pt-20 xl:pt-32 xl:w-9/12 w-11/12 h-screen"
          style={{ fontFamily: "sf-pro-medium" }}
        >
          <div className="grid grid-cols-10 pb-10 xl:pb-20 xl:h-24 h-32">
            <div className="col-start-1 text-blue-tikets xl:pt-10 pt-12 text-3xl w-auto whitespace-nowrap text-right">
              {t("tickets.buy_tickets")}
            </div>
            <div className="xl:col-start-3 col-start-4 col-end-13 mx-8 border-b-2 grow xl:mb-4 mb-10"></div>
          </div>

          {showTickets &&
            typeTicketsState &&
            typeTicketsState.map((item) => {
              return <Ticket key={item.id} item={item} language={props.language} />;
            })}
        </div>
      </div>
    </div>
  );
};

export default Tickets;
